export const APPLY_FILTER_QUERY = 'manage-modules/APPLY_FILTER_QUERY';
export const CHANGE_MODULE_CARD_FIELD =
  'manage-modules/CHANGE_MODULE_CARD_FIELD';
export const CHANGE_NEW_MODULE_CARD_THUMBNAIL =
  'manage-modules/CHANGE_NEW_MODULE_CARD_THUMBNAIL';
export const FETCH_MODULES = 'manage-modules/FETCH_MODULES';
export const FILTER_QUERY_CHANGED = 'manage-modules/FILTER_QUERY_CHANGED';
export const HIDE_DISCARD_NEW_MODULE_CONFIRMATION_DIALOG =
  'manage-modules/HIDE_DISCARD_NEW_MODULE_CONFIRMATION_DIALOG';
export const HIDE_REMOVE_MODULE_ITEMS_CONFIRMATION_DIALOG =
  'manage-modules/HIDE_REMOVE_MODULE_ITEMS_CONFIRMATION_DIALOG';
export const MODULES_LOADED = 'manage-modules/MODULES_LOADED';
export const MODULE_FIELD_SYNCED = 'manage-modules/MODULE_FIELD_SYNCED';
export const MODULE_ITEMS_LOADED = 'manage-modules/MODULE_ITEMS_LOADED';
export const MODULE_ITEMS_SYNCED = 'manage-modules/MODULE_ITEMS_SYNCED';
export const MODULE_THUMBNAIL_SYNCED = 'manage-modules/MODULE_THUMBNAIL_SYNCED';
export const NEW_MODULE = 'manage-modules/NEW_MODULE';
export const NEW_MODULE_CARD_INTERNAL_CODE_SUGGESTED =
  'manage-modules/NEW_MODULE_CARD_INTERNAL_CODE_SUGGESTED';
export const NEW_MODULE_PUBLISHED = 'manage-modules/NEW_MODULE_PUBLISHED';
export const PUBLISH_NEW_MODULE = 'manage-modules/PUBLISH_NEW_MODULE';
export const REMOVE_MODULE_CARD_ITEMS = 'manage-modules/REMOVE_MODULE_ITEMS';
export const SAVE_NEW_MODULE_CARD_FIELD =
  'manage-modules/SAVE_NEW_MODULE_CARD_FIELD';
export const SAVE_NEW_MODULE_CARD_FIELD_SUGGEST_AS_INTERNAL_CODE =
  'manage-modules/SAVE_NEW_MODULE_CARD_FIELD_SUGGEST_AS_INTERNAL_CODE';
export const SELECT_ALL_MODULE_ITEMS = 'manage-modules/SELECT_ALL_MODULE_ITEMS';
export const SELECT_MODULE = 'manage-modules/SELECT_MODULE';
export const SELECT_MODULE_ITEM = 'manage-modules/SELECT_MODULE_ITEM';
export const SHOW_DISCARD_NEW_MODULE_CONFIRMATION_DIALOG =
  'manage-modules/SHOW_DISCARD_NEW_MODULE_CONFIRMATION_DIALOG';
export const SHOW_EDIT_MODULE_CARD_THUMBNAIL =
  'manage-modules/SHOW_EDIT_MODULE_CARD_THUMBNAIL';
export const SHOW_MODULE_THUMBNAIL_URL =
  'manage-modules/SHOW_MODULE_THUMBNAIL_URL';
export const SHOW_NEW_MODULE_THUMBNAIL_URL =
  'manage-modules/SHOW_NEW_MODULE_THUMBNAIL_URL';
export const SHOW_MORE_MODULES = 'manage-modules/SHOW_MORE_MODULES';
export const SHOW_REMOVE_MODULE_ITEMS_CONFIRMATION_DIALOG =
  'manage-modules/SHOW_REMOVE_MODULE_ITEMS_CONFIRMATION_DIALOG';
export const SYNC_MODULE_CARD_FIELD = 'manage-modules/SYNC_MODULE_CARD_FIELD';
export const SYNC_MODULE_CARD_INTERNAL_CODE =
  'manage-modules/SYNC_MODULE_CARD_INTERNAL_CODE';
export const SYNC_MODULE_CARD_THUMBNAIL =
  'manage-modules/SYNC_MODULE_CARD_THUMBNAIL';
export const TAB_CHANGED = 'manage-modules/TAB_CHANGED';
